import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiUrlService} from "./api-url.service";
import {Anliegen} from "../../model/anliegen";
import {NachrichtenTypeEnum} from "../../model/nachricht/nachrichten-type.enum";

@Injectable({
    providedIn: 'root' // ✅ Ensures the service is available globally
})
export class AnliegenService {
    private readonly http: HttpClient = inject(HttpClient);
    private apiUrlService = inject(ApiUrlService);

    public getAnliegen(nachrichtenTypeEnum: NachrichtenTypeEnum, dienststellenNummer: string): Observable<Anliegen[]> {
        return this.http.get<Anliegen[]>(`${this.apiUrlService.getApiUrl()}/anliegen/${nachrichtenTypeEnum}/${dienststellenNummer}`);
    }
}
